export default {
  getRandomAudioClass() {
    var alphabet = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    return Array(5)
      .join()
      .split(",")
      .map(function() {
        return alphabet.charAt(Math.floor(Math.random() * alphabet.length));
      })
      .join("");
  },
  isToday(date) {
    const today = new Date();
    return (
      date.getDate() == today.getDate() &&
      date.getMonth() == today.getMonth() &&
      date.getFullYear() == today.getFullYear()
    );
  },
  getNowDateString() {
    const localISOTime = this.toLocalISOString(new Date());
    const now = localISOTime.substring(0, 10);
    return now;
  },
  toLocalISOString(date) {
    const isoDateTime = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000
    ).toISOString();
    return isoDateTime;
  },
  colors: {
    green: "rgba(23, 194, 0, 0.7)",
    red: "rgba(235, 64, 52, 0.7)",
    blue: "rgba(54, 162, 235, 0.7)",
    purple: "rgba(153, 102, 255, 0.7)",
    orange: "rgba(255, 159, 64, 0.7)"
  }
};
